// Survey Types and Enums

export enum CreationMethod {
  MANUAL = 'manual',
  AI = 'ai',
}

export enum AnswerType {
  TEXT = 'text',
  RATING = 'rating',
  MULTIPLE_CHOICE = 'multiple_choice',
  YES_NO = 'yes_no',
  NUMBER = 'number', // For ratings/numeric input
}

// UI Types (for form components)
export type QuestionType = 'rating' | 'text' | 'number' | 'yesno' | 'multiple_choice';

export interface QuestionFormData {
  question: string;
  answerType: string;
  isMandatory: boolean;
  options?: string[];
}

// Combined SurveyQuestion interface (supports both UI and API formats)
export interface SurveyQuestion {
  id?: string; // UI only
  question?: string; // UI format
  question_text?: string; // API format
  answerType?: string; // UI format
  answer_type?: string | AnswerType; // API format
  isMandatory?: boolean; // UI format
  is_mandatory?: boolean; // API format
  question_order?: number; // API format
  placeholder?: string; // UI only
  options?: string[]; // For multiple_choice type
}

// API-specific types
export interface ApiSurveyQuestion {
  question_text: string;
  answer_type: AnswerType | string;
  is_mandatory: boolean;
  question_order: number;
  options?: string[];
}

export interface CreateSurveyRequest {
  campaign_id: string;
  survey_name: string;
  description: string;
  creation_method: CreationMethod | string;
  questions: ApiSurveyQuestion[];
}

export interface SurveyData {
  id: string;
  campaign_id: string;
  survey_name: string;
  description: string;
  creation_method: string;
  questions: SurveyQuestionData[];
  created_at?: string;
  updated_at?: string;
}

export interface SurveyQuestionData extends SurveyQuestion {
  id: string;
  survey_id: string;
}

export interface CreateSurveyResponse {
  success: boolean;
  data?: {
    message: string;
    survey: SurveyData;
  };
  message?: string;
}

export interface GetSurveysResponse {
  success: boolean;
  data?: {
    surveys: SurveyData[];
    total: number;
  };
  message?: string;
}

// Form data types for UI
export interface SurveyFormData {
  campaignId: string;
  surveyName: string;
  description: string;
  creationMethod: CreationMethod | string;
  questions: SurveyQuestion[];
}
